/**
 * Типы для drag-and-drop функциональности
 * Используются для реализации перетаскивания элементов в админ-панели
 */

/**
 * Тип элемента для drag-and-drop
 */
export const DRAG_TYPES = {
  DOCTOR_ROW: 'doctor-row',
  PRICE_ITEM_ROW: 'price-item-row',
  GALLERY_TILE: 'gallery-tile'
} as const;

/**
 * Интерфейс для перетаскиваемого элемента врача
 */
export interface DraggedDoctorItem {
  type: typeof DRAG_TYPES.DOCTOR_ROW;
  id: number;
  index: number;
  sortOrder: number;
}

/**
 * Результат операции drop для врача
 */
export interface DoctorDropResult {
  targetIndex: number;
  targetSortOrder: number;
}

/**
 * Данные для обновления порядка сортировки врачей
 */
export interface DoctorSortOrderUpdate {
  id: number;
  sortOrder: number;
}

/**
 * Интерфейс для перетаскиваемого элемента услуги
 */
export interface DraggedPriceItemItem {
  type: typeof DRAG_TYPES.PRICE_ITEM_ROW;
  id: number;
  index: number;
  sortOrder: number;
}

/**
 * Результат операции drop для услуги
 */
export interface PriceItemDropResult {
  targetIndex: number;
  targetSortOrder: number;
}

/**
 * Данные для обновления порядка сортировки услуг
 */
export interface PriceItemSortOrderUpdate {
  id: number;
  sortOrder: number;
}

/**
 * Перетаскиваемое фото ленты на главной. sortOrder не нужен: порядок
 * пересчитывается по позициям после отпускания.
 */
export interface DraggedGalleryTile {
  type: typeof DRAG_TYPES.GALLERY_TILE;
  id: number;
  index: number;
}

/**
 * Ответ API для массового обновления порядка сортировки
 */
export interface BulkSortOrderUpdateResponse {
  success: boolean;
  updatedCount: number;
  doctors: Array<{
    id: number;
    sortOrder: number;
  }>;
}
